const isDev = import.meta.env.DEV;

export const logger = {
  info: (...args: unknown[]) => {
    if (isDev) console.log('[CleanHands]', ...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn('[CleanHands]', ...args);
  },
  error: (...args: unknown[]) => {
    console.error('[CleanHands]', ...args);
  },
};
